<ul class="payment-fields__list">
  @for (field of fields(); track $index) {
    <li class="payment-fields__list_item">
      @if (field.type === WooCommercePaymentFieldType.Radio) {
        <div class="payment-fields__field">
          <!-- <span class="payment-fields__field_label">{{ field.label }}</span> -->
          <ul class="payment-fields__field_radio_list">
            @for (option of field.options | keyvalue; track $index) {
              <li class="payment-fields__field_radio_item">
                <app-radio
                  [name]="field.name"
                  [radioValue]="option.key"
                  [label]="option.value"
                  [formControlName]="field.name"
                />
              </li>
            }
          </ul>
        </div>
      }
      @if (field.type === WooCommercePaymentFieldType.Checkbox) {
        <div class="payment-fields__field">
          <app-checkbox
            [label]="field.label"
            [formControlName]="field.name"
          />
        </div>
      }
      @if (field.type === WooCommercePaymentFieldType.Text || field.type === WooCommercePaymentFieldType.Tel) {
        @let maskConfig = getPaymentFieldMask(field.name);
        <div class="payment-fields__field">
          <app-editable-row
            [placeholder]="field.placeholder || field.label"
            [mask]="maskConfig?.mask"
            [showMaskTyped]="maskConfig?.showMaskTyped || false"
            [hiddenInput]="maskConfig?.hiddenInput || false"
            [type]="maskConfig?.type || 'text'"
            [formControlName]="field.name"
            [autocomplete]="getPaymentFieldAutocomplete(field.name)"
          />
        </div>
      }
    </li>
  }
</ul>

